import { render, staticRenderFns } from "./StartMoneyTreeConfig.vue?vue&type=template&id=09a88b7f&scoped=true&"
import script from "./StartMoneyTreeConfig.vue?vue&type=script&lang=js&"
export * from "./StartMoneyTreeConfig.vue?vue&type=script&lang=js&"
import style0 from "./StartMoneyTreeConfig.vue?vue&type=style&index=0&id=09a88b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a88b7f",
  null
  
)

export default component.exports